import {Component, Input} from '@angular/core';
import {Utils} from '@astek/utils';
import {AvailablePatientOptions} from '../../services/data/patient/available-patient-options';

@Component({
  selector: 'xp-patient-feature-list',
  templateUrl: './patient-feature-list.component.html',
  styleUrl: './patient-feature-list.component.scss'
})
export class PatientFeatureListComponent {

  @Input({required: true})
  public features: AvailablePatientOptions | null = null;

  constructor() {
  }

  public get hasFeatures(): boolean {
    return Utils.isNotNullOrUndefined(this.features);
  }
}
